module.exports = __webpack_public_path__ + "img/Komisaris-Utama-Bahrodji.762b3e66.jpg";